/*
 * Copyright (c) CIRROM 2025.
 */

import React, { useContext } from "react";
import styled from "@emotion/styled";

import { IconButton } from "@mui/material";
import {
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";

import { MiraTheme } from "../../theme/theme";
import { SideBarWidthContext } from "../../../../App";

const Footer = styled.div<{ theme?: MiraTheme }>`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

export const SidebarFooter: React.FC<{
  currentUser: string;
  isCollapsed?: boolean;
}> = ({ currentUser, isCollapsed = false, ...rest }) => {
  const sideBarWidth = useContext(SideBarWidthContext);

  if (isCollapsed) {
    return (
      <Footer
        {...rest}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <IconButton
          onClick={() => sideBarWidth.toggleValue()}
          size="small"
          sx={{ padding: "4px" }}
        >
          <KeyboardDoubleArrowRight fontSize="small" />
        </IconButton>
      </Footer>
    );
  }

  return (
    <Footer {...rest}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "8px",
        }}
      >
        <IconButton
          onClick={() => sideBarWidth.toggleValue()}
          size="small"
          sx={{ padding: "4px" }}
        >
          <KeyboardDoubleArrowLeft fontSize="small" />
        </IconButton>
      </div>
    </Footer>
  );
};
